export default __webpack_public_path__ + "static/media/contact-3.2ed74e4c.png";